<template>
  <section class="section">
      <div class="columns is-centered">
        <div class="column is-one-third">
          <div class="has-text-centered" style="margin-bottom: 1rem;">
            <span style="font-size: 1.75rem; font-weight: 700; letter-spacing: -0.5px; color: #3273dc;">Fooshi</span>
          </div>
          <div class="has-text-centered" style="margin-bottom: 1.5rem;">
            <LanguageSelector />
          </div>
          <h3 class="title is-4 is-spaced is-centered">
            <span>{{ $t('onboarding.resetPassword.title') }}</span>
          </h3>
          <template v-if="invalidLink">
            <div class="notification is-danger is-light">
              {{ $t('onboarding.resetPassword.invalidToken') }}
            </div>
            <div class="field">
              <p class="control">
                <primary-button :label="$t('onboarding.resetPassword.requestNewLink')" @click="requestNewLink()" class="is-fullwidth"></primary-button>
              </p>
            </div>
          </template>
          <template v-else>
            <div class="field">
              <label class="label">{{ $t('onboarding.resetPassword.newPassword') }}</label>
              <p class="control has-icons-left has-icons-right">
                <input v-focus class="input" :type="passwordFieldType" placeholder="Password" autocomplete="new-password" v-model="newPassword"
                    @input="errorMessage = ''"
                    v-bind:class="{
                      'is-danger': errors && !validPassword
                    }" />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
                <span class="icon is-small is-right">
                  <i v-bind:class="{
                    'fa': true,
                    'fa-eye': !showPassword,
                    'fa-eye-slash': showPassword
                    }"
                    style="pointer-events: all; cursor: pointer"
                    @click="showHidePassword()">
                  </i>
                </span>
              </p>
              <p class="help" v-bind:class="{ 'is-danger': errors && !validPassword }">
                {{ $t('onboarding.resetPassword.invalidPassword') }}
              </p>
            </div>
            <div class="field">
              <label class="label">{{ $t('onboarding.resetPassword.repeatPassword') }}</label>
              <p class="control has-icons-left">
                <input class="input" :type="passwordFieldType" placeholder="Password" autocomplete="new-password" v-model="repeatPassword"
                    @input="errorMessage = ''"
                    v-on:keyup.enter="submit()"
                    v-bind:class="{
                      'is-danger': errors && newPassword !== repeatPassword
                    }" />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </p>
              <p class="help is-danger" v-if="errors && newPassword !== repeatPassword">
                {{ $t('onboarding.signup.passwordsMismatch') }}
              </p>
            </div>
            <p class="help is-danger block" v-if="errorMessage">
              {{ $t(errorMessage) }}
            </p>
            <div class="field">
              <p class="control">
                <primary-button :label="$t('onboarding.resetPassword.submit')" @click="submit()" class="is-fullwidth" :loading="loading"></primary-button>
              </p>
            </div>
          </template>
          <div class="field">
            <p class="control">
              <button class="button is-info is-light is-fullwidth" @click="backToLogin()">{{ $t('onboarding.forgotPassword.backToLogin') }}</button>
            </p>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

import { FooshiApi } from '@/services/fooshiApi.service'
import PrimaryButton from '../../components/forms/PrimaryButton.vue'
import LanguageSelector from '../../components/LanguageSelector.vue'

// Mirrors the User model's password validator in the API, which only counts
// these characters as special.
const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/
const TOKEN_FORMAT = /^[0-9a-f]{64}$/

export default {
  components: { PrimaryButton, LanguageSelector },
  computed: {
    token () {
      return this.$route.query.token || ''
    },
    validPassword () {
      return PASSWORD_RULE.test(this.newPassword)
    }
  },
  methods: {
    async submit () {
      if (!this.validPassword || this.newPassword !== this.repeatPassword) {
        this.errors = true
        return
      }
      this.loading = true
      try {
        await FooshiApi.resetPassword({
          token: this.token,
          newPassword: this.newPassword,
          repeatPassword: this.repeatPassword
        })
        if (window.plausible) window.plausible('Password Reset Completed', { props: { stage: 'retention' } })
        this.$router.push({ path: '/login', query: { reset: 'done' } })
      } catch (err) {
        if (err.message === 'resetPassword.invalidToken') {
          this.invalidLink = true
        } else if (err.message === 'resetPassword.invalidPassword' || err.message === 'resetPassword.passwordsMismatch') {
          this.errors = true
          this.errorMessage = `onboarding.${err.message}`
        } else if (err.status === 429) {
          this.errorMessage = 'onboarding.forgotPassword.rateLimited'
        } else {
          this.errorMessage = 'onboarding.forgotPassword.genericError'
        }
      }
      this.loading = false
    },
    requestNewLink () {
      this.$router.push('/forgot-password')
    },
    backToLogin () {
      this.$router.push('/login')
    },
    showHidePassword () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
      this.showPassword = !this.showPassword
    }
  },
  data () {
    return {
      loading: false,
      errors: false,
      errorMessage: '',
      invalidLink: !TOKEN_FORMAT.test(this.$route.query.token || ''),
      passwordFieldType: 'password',
      showPassword: false,
      newPassword: '',
      repeatPassword: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/onBoarding/ResetPassword.vue